import { useTranslation } from 'react-i18next';
import { Button } from '@shared/components/ui/button';

interface ErrorStateProps {
  error: Error;
  onRetry: () => void;
  className?: string;
  title?: string;
}

// 🎯 Single Responsibility Principle (SRP)
// Este componente SOLO maneja estados de error
export const ErrorState = ({ error, onRetry, className = 'h-64', title }: ErrorStateProps) => {
  const { t } = useTranslation('productsWithoutStockModule');

  return (
    <div className={'flex items-center justify-center ' + className}>
      <div className="text-center">
        <div className="text-error text-4xl mb-4">⚠️</div>
        <h3 className="text-lg font-semibold text-title mb-2">
          {title ||
            t('error.title', {
              defaultValue: 'Error al cargar productos sin stock',
            })}
        </h3>
        <p className="text-subtext mb-4">{error.message}</p>
        <Button onClick={onRetry} variant="primary" data-testid="retry-button" className="mx-auto">
          {t('error.retry', { defaultValue: 'Reintentar' })}
        </Button>
      </div>
    </div>
  );
};
